import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "credentials-selected"
};
const _hoisted_2 = { class: "credentials-selected__value" };
const _hoisted_3 = { class: "credentials-selected__actions" };
const _hoisted_4 = {
    key: 1,
    class: "credentials-selected"
};
const _hoisted_5 = { class: "credentials-selected__actions" };
const _hoisted_6 = {
    key: 2,
    class: "credentials"
};
import { ref, watch } from "vue";
import Icon from "../Icon.vue";
import DataTable from "../DataTable.vue";
import serviceLocator from "../../services/ServiceLocator";
import log from "../../services/Logger";
const app = 'data'; // TODO inject? env?
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlCredentials',
    props: {
        data: {},
        field: {},
        validation: {}
    },
    emits: [
        'change',
    ],
    setup(__props, { emit: __emit }) {
        const credentials = serviceLocator.get('credentials');
        const props = __props;
        const emit = __emit;
        // TODO add entry, edit, clear
        const showCredentials = ref(false);
        const grid = ref(null);
        const source = credentials.gridItemsSource(app);
        watch(showCredentials, show => {
            if (show && !grid.value) {
                credentials.getGridConfig(app)
                    .then(data => grid.value = data);
            }
        });
        function clear() {
            emit('change', null);
            showCredentials.value = false;
        }
        function onSelect(item) {
            log('FieldControlCredentials@change', props.field.name, item.title);
            emit('change', item.title);
            showCredentials.value = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["form__control form__control--credentials", { 'form__control--credentials-empty': !__props.data }])
            }, [
                (__props.data)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(Icon, { name: "key" }),
                            _createTextVNode(" " + _toDisplayString(__props.data), 1)
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("a", {
                                onClick: _withModifiers(clear, ["prevent"]),
                                href: ""
                            }, [
                                _createVNode(Icon, { name: "cancel" })
                            ]),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            _createElementVNode("a", {
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (showCredentials.value = !showCredentials.value), ["prevent"])),
                                href: ""
                            }, [
                                _createVNode(Icon, { name: "edit" })
                            ])
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("a", {
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (showCredentials.value = !showCredentials.value), ["prevent"])),
                                href: "#"
                            }, [
                                _createVNode(Icon, { name: "key" }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('form_field_credentials_select')), 1)
                            ])
                        ])
                    ])),
                _cache[4] || (_cache[4] = _createTextVNode()),
                (showCredentials.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (grid.value)
                            ? (_openBlock(), _createBlock(DataTable, {
                                key: 0,
                                grid: grid.value,
                                source: _unref(source),
                                name: app + '-integration_credentials_config',
                                onActivateItem: onSelect,
                                variant: "condensed",
                                mode: "list"
                            }, null, 8, ["grid", "source", "name"]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
